import Tip, { TIP_TRANSITION_DURATION } from './Tip';
import { showWithTransition } from '../../utils/show';
import { wrapWithConfigDefaults } from '../../utils/helper';
export default wrapWithConfigDefaults(function (config) {
    var _a = config.autoClose, autoClose = _a === void 0 ? true : _a;
    delete config.autoClose;
    return showWithTransition({
        Component: Tip,
        transitionDuration: TIP_TRANSITION_DURATION,
        autoClose: autoClose,
        injectClosePropNames: ['onClickAction', 'onClose'],
        props: config,
        contexts: config.contexts,
    });
});
